import React, {FC} from 'react';

interface IToggleButtonProps {
  id?: string;
  isActive: boolean;
  activeTag: React.ReactNode;
  inactiveTag: React.ReactNode;
  onToggle: (isActive: boolean) => void;
  baseClass: string;
  activeClass: string;
  inactiveClass: string;
  firstTooltip?: string;
  secondTooltip?: string;
}

const ToggleButton: FC<IToggleButtonProps> = ({
                        id,
                        isActive,
                        activeTag,
                        inactiveTag,
                        onToggle,
                        baseClass,
                        activeClass,
                        inactiveClass,
                        firstTooltip,
                        secondTooltip
                      }) => {
  return (
    <div id={id} className={baseClass}>
      <div className={`${!isActive ? `${inactiveClass} ${activeClass}` : `${inactiveClass}`} ss-circle-container`}
           data-tip data-for={firstTooltip ? firstTooltip : ''}
           onClick={() => onToggle(false)}>
        <div className={`ss-circle-box ${!isActive && `active`}`}>
          {!isActive && <div className='ss-circle-main'/>}
        </div>
        {inactiveTag}
      </div>
      <div className={`${!isActive ? `${inactiveClass} ${activeClass}` : `${inactiveClass}`} ss-circle-container`}
           data-tip data-for={secondTooltip ? secondTooltip : ''}
           onClick={() => onToggle(true)}>
        <div className={`ss-circle-box ${isActive && `active`}`}>
          {isActive && <div className='ss-circle-main'/>}
        </div>
        {activeTag}
      </div>
    </div>
  );
}

export default ToggleButton;